import React from "react"
import { Link, graphql } from "gatsby"

import Layout from "../components/layout"
import SEO from "../components/seo"
import Img from "gatsby-image"

class BlogIndex extends React.Component {
  render() {
    const { data } = this.props
    const siteTitle = data.site.siteMetadata.title
    const siteDescription = data.site.siteMetadata.description
    const projects = data.allContentfulRecord.edges
    const logo = this.props.data.logo
    const blogPosts = data.allContentfulBlogPost.edges
    const tickerItems = this.props.data.allContentfulTickerItems

    let posts = blogPosts.map(post => {
      return (
        <div class="blog-preview">
          <Img fluid={post.node.blogImage.fluid} />
          <div class="blog-preview-info">
            <h1>{post.node.blogTitle}</h1>
            <p class="blog-subtitle">{post.node.blogSubtitle}</p>
            <Link class="read-more" to={"/blog/" + post.node.slug + "/"}>
              Read more
            </Link>
          </div>
        </div>
      )
    })

    return (
      <Layout
        location={this.props.location}
        title={siteTitle}
        description={siteDescription}
        projects={projects}
        logo={logo}
        tickerItems={tickerItems}
      >
        <SEO title="All posts" />
        <section class="blog-list">{posts}</section>
      </Layout>
    )
  }
}

export default BlogIndex

export const pageQuery = graphql`
  query {
    site {
      siteMetadata {
        title
        description
      }
    }
    logo: file(relativePath: { eq: "dustworldlogoblack.png" }) {
      childImageSharp {
        fixed(width: 120, height: 120) {
          ...GatsbyImageSharpFixed
        }
      }
    }
    allContentfulRecord {
      edges {
        node {
          title
          producer
          slug
          catalog
          sort
        }
      }
    }
    allContentfulTickerItems {
      nodes {
        tickerTitle
        tickerContent {
          tickerContent
        }
        createdAt
        link {
          link
        }
      }
    }
    allContentfulBlogPost {
      edges {
        node {
          blogTitle
          blogSubtitle
          slug
          createdAt(locale: "")
          blogImage {
            fluid(maxWidth: 800) {
              src
              sizes
              srcSet
              aspectRatio
            }
          }
        }
      }
    }
  }
`
